import { defineStore } from 'pinia'
import api from '@/store/api'

export const useWwStore = defineStore('ww', {
  state: () => ({
    init: false,
    quarters: [],
    sectors: [],
    classifications: [],
    countries: [],
    stock_countries: [],
    secCodeStates: [],
    states: [],
    investing_styles: [],
    wwGroups: [],
    ownershipTCodes: [],
    global_countries: [],
    global_exchanges: [],
    news: [],
    market_caps: [
      { id: 1, name: 'Over $200 billion', from: null, to: null, selected: false },
      { id: 2, name: '$100 billion to $500 billion', from: null, to: null, selected: false },
      { id: 3, name: '$50 billion to $100 billion', from: null, to: null, selected: false },
      { id: 4, name: '$20 billion to $50 billion', from: null, to: null, selected: false },
      { id: 5, name: '$10 billion to $20 billion', from: null, to: null, selected: false },
      { id: 6, name: '$2 billion to $10 billion', from: null, to: null, selected: false },
      { id: 7, name: '$1 billion to $2 billion', from: null, to: null, selected: false },
      { id: 8, name: '$500 million to $1 billion', from: null, to: null, selected: false },
      { id: 9, name: '$250 million to $500 million', from: null, to: null, selected: false },
      { id: 10, name: 'Less than $250 million', from: null, to: null, selected: false }
    ]
  }),

  getters: {
    currentQuarter: state => {
      return state.quarters.find(q => q.is_current) || state.quarters[state.quarters.length - 1]
    },

    allowedClassifications: state => allowedArray => {
      return state.classifications
        .filter(obj => allowedArray.includes(obj.id))
        .map(obj => ({
          id: obj.id,
          description: obj.name,
          count: 0,
          full_description: `Fund Classification: ${obj.name}`,
          filter_identifier: 'fund_classification'
        }))
    }
  },

  actions: {
    setQuarters(quarters) {
      this.quarters = quarters
    },

    setSectors(sectors) {
      this.sectors = sectors
    },

    setClassifications(classifications) {
      this.classifications = classifications
    },

    setCountries(countries) {
      this.countries = countries
    },

    setGlobalCountries(countries) {
      this.global_countries = countries
    },

    setGlobalExchanges(exchanges) {
      this.global_exchanges = exchanges
    },

    setStockCountries(countries) {
      this.stock_countries = countries
    },

    setSECCodeStates(secCodeStates) {
      this.secCodeStates = secCodeStates
    },

    setStates(states) {
      this.states = states
    },

    setWWGroups(wwGroups) {
      this.wwGroups = wwGroups
    },

    setOwnershipTCodes(ownershipTCodes) {
      this.ownershipTCodes = ownershipTCodes
    },

    setNews(news) {
      this.news = news
    },

    setInvestingStyles(investing_styles) {
      this.investing_styles = investing_styles
    },

    // API Actions
    async loadQuarters() {
      try {
        const res = await api.get('quarter')
        this.setQuarters(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadSectors() {
      try {
        const res = await api.get('sector')
        this.setSectors(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadClassifications() {
      try {
        const res = await api.get('fund_classifications')
        this.setClassifications(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadInvestingStyles() {
      try {
        const res = await api.get('investing_styles')
        this.setInvestingStyles(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadStockCountries() {
      try {
        const res = await api.get('stock_country')
        this.setStockCountries(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadCountries() {
      try {
        const res = await api.get('country')
        this.setCountries(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadSECCodeStates() {
      try {
        const res = await api.get('sec_code_state')
        this.setSECCodeStates(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadStates() {
      try {
        const res = await api.get('state')
        this.setStates(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadGlobalCountries() {
      try {
        const res = await api.get('global_country')
        this.setGlobalCountries(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadGlobalExchanges() {
      try {
        const res = await api.get('global_exchanges')
        this.setGlobalExchanges(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadWWGroups() {
      try {
        const res = await api.get('groups.json?groups=ww&isArray=true')
        this.setWWGroups(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadOwnershipTCodes() {
      try {
        const res = await api.get('ownership_transaction_code')
        this.setOwnershipTCodes(res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async loadNews() {
      try {
        const res = await api.get('news')
        this.setNews(res.data)
      } catch (error) {
        console.log(error)
      }
    }
  }
})
